"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SecurePhrase = void 0;
var randomBytes = require("randombytes");
var aesjs = require("aes-js");
var createHmac = require("create-hmac");
var pbkdf2_1 = require("pbkdf2");
var pkcs7_1 = require("pkcs7");
// Port of https://gitlab.com/zenprotocol/zenprotocol/blob/master/src/Infrastructure/Security.fs
var SaltSize = 16;
var KeySize = 32;
var AuthKeySize = 16;
var IVSize = 16;
var MacSize = 32;
function derive(password, salt) {
    var derived = pbkdf2_1.pbkdf2Sync(password, salt, 1000, KeySize + AuthKeySize + IVSize);
    var key = derived.slice(0, KeySize);
    var authKey = derived.slice(KeySize, KeySize + AuthKeySize);
    var iv = derived.slice(KeySize + AuthKeySize, KeySize + AuthKeySize + IVSize);
    return [authKey, iv, key];
}
var SecurePhrase;
(function (SecurePhrase) {
    var Buffer = require('buffer').Buffer;
    function encrypt(password, msg, encoding) {
        if (encoding === void 0) { encoding = 'utf8'; }
        var plain = Buffer.from(msg, encoding);
        var salt = randomBytes(SaltSize);
        var _a = derive(password, salt), authKey = _a[0], iv = _a[1], key = _a[2];
        var encryptor = new aesjs.ModeOfOperation.cbc(key, iv);
        var cipher = Buffer.from(encryptor.encrypt(pkcs7_1.pad(plain)));
        var hmac = createHmac('sha256', authKey);
        hmac.update(cipher);
        var hash = hmac.digest();
        return Buffer.concat([salt, hash, cipher]).toString('hex');
    }
    SecurePhrase.encrypt = encrypt;
    function decrypt(password, encrypted, encoding) {
        if (encoding === void 0) { encoding = 'utf8'; }
        var data = Buffer.from(encrypted, 'hex');
        var salt = data.slice(0, SaltSize);
        var hash = data.slice(SaltSize, SaltSize + MacSize);
        var cipher = data.slice(SaltSize + MacSize);
        var _a = derive(password, salt), authKey = _a[0], iv = _a[1], key = _a[2];
        var hmac = createHmac('sha256', authKey);
        hmac.update(cipher);
        var hash2 = Buffer.from(hmac.digest());
        if (!hash2.equals(hash)) {
            throw new Error('bad password');
        }
        else {
            var encryptor = new aesjs.ModeOfOperation.cbc(key, iv);
            var plain = Buffer.from(encryptor.decrypt(cipher));
            return Buffer.from(pkcs7_1.unpad(plain)).toString(encoding);
        }
    }
    SecurePhrase.decrypt = decrypt;
})(SecurePhrase = exports.SecurePhrase || (exports.SecurePhrase = {}));
exports.default = SecurePhrase;
//# sourceMappingURL=SecurePhrase.js.map